












































import { Component, Vue } from 'vue-property-decorator';

import { ErrorMessage } from '@/common/errors';
import { WraLoader } from '@/common/loader';
import StandardLayout from '@/layouts/standard/StandardLayout.vue';
import ReportPageEmptyState from '@/pages/reports/components/ReportPageEmptyState.vue';
import ReportPageList from '@/pages/reports/components/ReportPageList.vue';
import { ReportStore } from '@/store/report';

@Component({
  components: {
    ErrorMessage,
    ReportPageEmptyState,
    ReportPageList,
    StandardLayout,
    WraLoader,
  },
})
export default class ReportPage extends Vue {

  @ReportStore.Bind.State isFetching!: ReportStore.State<'isFetching'>;
  @ReportStore.Bind.State value!: ReportStore.State<'value'>;

}
